// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607270134/js/" + chunkId + "." + {"44":"d23befca","225":"af34bde6","481":"d05d9399","486":"e2c37968","770":"b3830ae7"}[chunkId] + ".0.48134261156965674.chunk.js";
};